
import Survey from "@/models/Survey";
import router from "@/router/route.js";

export const Templates = {
  computed: {
    templateList() {
      return  ['Hotjar', 'Basecamp', 'Webflow', 'Autopilot', 'ClickUp', 'Codecademy', 'Invision', 'Airtable' ];
    },
  },
  methods: {
    async lazyLoad(template){
      let result = await import(`@/mixins/SurveyTemplates/${template}.js`);
      
      return result.default;
    },
    async previewTemplate(template=null){

      let surveyData = await this.lazyLoad(template);
    
      surveyData.user_id = this.$store.state.auth.user.id;

      //Add temporary survey to app state w/o persisting to database
      let survey = await Survey.insertNew({ data: surveyData });

      router.push({ path: `/demo/${survey.id}/start` }); // -> /user/123

    },
    async useTemplate(template = null) {
      let surveyData = await this.lazyLoad(template);

      //console.dir(surveyData);
      //console.log('user: ' + this.$store.state.auth.user.id);
    
      surveyData.user_id = this.$store.state.auth.user.id;

      //Add new survey to app state; note insertNew returns survey model ONLY w/o steps or options
      let surveyModel = await Survey.insertNew({ data: surveyData });

      //Get the full nested survey object
      let survey = Survey.query()
        .whereId(surveyModel.id)
        .with("steps", (query) => {
          query
            .orderBy("order", "asc")
            .with("options", (query) => {
              query.orderBy("order", "asc").with("contents", (query) => {
                query.orderBy("order", "asc");
              });
            })
            .with("rows", (query) => {
              query.orderBy("order", "asc").with("columns", (query) => {
                query.orderBy("order", "asc").with("contents", (query) => {
                  query.orderBy("order", "asc");
                });
              });
            });
        })
        .first();

      //Save full survey to backend database
      var result = await Survey.api().post("/api/survey/save", survey);

      if (result.response.status == 200) {
        //Launch survey buider with new survey
        router.push({ path: `/builder/${survey.id}` }); // -> /user/123
      } else {
        this.$store.dispatch("notification/add", {
          message: "An error occured: " + result.response.data.error.message,
        });
      }
    },
  },
};
